module.exports = __webpack_public_path__ + "static/media/self-onboarded-students.a89f8cd5.svg";